import store from "@/state/store";

export default [
  {
    path: "/",
    name: "home",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/index"),
  },
  {
    path: "/contacts",
    name: "contacts",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/contacts/index"),
  },
  {
    path: "/contacts/:id",
    name: "contact",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/contacts/item"),
  },
  {
    path: "/companies",
    name: "companies",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/companies/index"),
  },
  {
    path: "/companies/:id",
    name: "company",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/companies/item"),
  },
  {
    path: "/agents",
    name: "agents",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/agents/index"),
  },
  {
    path: "/agents/:id",
    name: "agent",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/agents/item"),
  },
  {
    path: "/crm-users",
    name: "crm-users",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/crm-users/index"),
  },
  {
    path: "/groups",
    name: "groups",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/groups/index"),
  },
  {
    path: "/groups/:id",
    name: "group",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/groups/item"),
  },
  {
    path: "/mailbox",
    name: "mailbox",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/mailbox/index"),
  },
  {
    path: "/servers",
    name: "servers",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/servers/index"),
  },
  {
    path: "/servers/:id",
    name: "servers-id",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/servers/item"),
  },
  {
    path: "/mailboxes",
    name: "system-settings-mailboxes",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/mailboxes/index"),
  },
  {
    path: "/mailboxes/:id",
    name: "mailboxes-id",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/mailboxes/item"),
  },
  {
    path: "/email/all",
    name: "all-email",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/mailbox/index"),
  },
  {
    path: "/email/inbox",
    name: "inbox-email",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/mailbox/index"),
  },
  {
    path: "/email/outbox",
    name: "outbox-email",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/mailbox/index"),
  },
  {
    path: "/email/scheduled",
    name: "scheduled-email",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/mailbox/index"),
  },
  {
    path: "/email/drafts",
    name: "drafts-email",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/mailbox/index"),
  },
  {
    path: "/email/selected",
    name: "selected-email",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/mailbox/index"),
  },
  {
    path: "/email/archived",
    name: "archived-email",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/mailbox/index"),
  },

  {
    path: "/crm-users/:id",
    name: "crm-user",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/crm-users/item"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/pages/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },

  /*  {
    path: "/register",
    name: "Register",
    component: () => import("../views/pages/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/pages/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  }, */
  {
    path: "/error/404-basic",
    name: "error-404-basic",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/errors/404-basic"),
  },
  {
    path: "/error/404-cover",
    name: "error-404-cover",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/errors/404-cover"),
  },
  {
    path: "/error/500-basic",
    name: "error-500-basic",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/errors/500-basic"),
  },
  {
    path: "/error/500-cover",
    name: "error-500-cover",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/errors/500-cover"),
  },
];
